import { Dropdown, Space } from 'antd'
import {
  DownOutlined,
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  ImportOutlined,
  PlusOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { createElement, forwardRef } from 'react'

import { ComponentController } from './component_controller'
import { AedIcon } from './custom_icons'

type IconType = 'aed' | 'import' | 'plus' | 'file' | 'pdf' | 'excel' | 'check'

const iconMap: Record<IconType, JSX.Element> = {
  aed: createElement(AedIcon),
  import: createElement(ImportOutlined),
  plus: createElement(PlusOutlined),
  file: createElement(FileOutlined),
  pdf: createElement(FilePdfOutlined),
  excel: createElement(FileExcelOutlined),
  check: createElement(CheckCircleOutlined),
}

type ButtonDropdownProps = {
  actions: {
    icon?: IconType
    label: string
    url?: string
    formaction?: string
    data?: Record<string, string>
    className?: string
  }[]
  className?: string
  label: string
  formId?: string
}

type ButtonDropdownTargetProps = {
  className?: string
  label: string
}

const ButtonDropdownTarget = forwardRef(
  ({ className, label, ...rest }: ButtonDropdownTargetProps, ref) =>
    createElement(
      'button',
      {
        className,
        ref,
        ...rest,
      },
      createElement(Space, null, label, createElement(DownOutlined)),
    ),
)
const ButtonDropdown = ({
  actions,
  className = 'button button--medium button--primary',
  label,
  formId,
}: ButtonDropdownProps) => {
  const items: MenuProps['items'] = actions.map(
    ({ icon, label, url, formaction, data, className }) => ({
      key: url || formaction || label,
      icon: icon ? iconMap[icon] : undefined,
      label: formaction
        ? createElement(
            'button',
            {
              type: 'submit',
              formAction: formaction,
              form: formId,
              className: className || 'button--link',
              ...(data || {}),
            },
            label,
          )
        : createElement(
            url ? 'a' : 'span',
            {
              href: url,
              ...(data || {}),
            },
            label,
          ),
    }),
  )
  const button = createElement(ButtonDropdownTarget, { className, label })
  return createElement(
    Dropdown,
    { menu: { items }, trigger: ['click'] },
    button,
  )
}

export class ButtonDropdownController extends ComponentController {
  get component() {
    return ButtonDropdown
  }
}
